export default "__VITE_ASSET__Czcg6bex__"